/* eslint-disable i18next/no-literal-string -- not visible to user */
export const FeatureFlag = {
  HAS_SCENARIOS: 'scenarios_client-feature',
  HAS_CLIMATE: 'climate_client-feature',
  GENERAL_FILE_REPOSITORY: 'file-repository',
  HAS_MONITORING: 'monitoring_client-feature',
  HAS_CLIMATE_SCORECARD: 'climate-scorecard_client-feature',
  HAS_CALC: 'calc_internal-feature',
  HAS_EXPLAINABILITY: 'explainability_internal-feature',
  HAS_AUDIT_EXCLUDED_BORROWERS: 'audit_excluded-borrowers',
  HAS_LOANBOOK_ANALYSIS: 'loanbook-analysis_client-feature',
};
/* eslint-enable i18next/no-literal-string */
